import withRoot from "../../../modules/withRoot" // --- Post bootstrap -----
import React from "react"
import AppFooter from "../../../modules/views/AppFooter"
import Questions from "../../../modules/views/Questions"
import AppAppBar from "../../../modules/views/AppAppBar"
import Typography from "../../../modules/components/Typography"

const questions = [
  "Irritabilidad",
  "Diarrea",
  "Vómito",
  "Escalofríos",
  "Dolor de estómago",
  "Dolor de cuerpo",
  "Malestar general",
  "Secreción nasal",
  "Respiración rápida",
  "Dolor en garganta",
  "Conjuntivitis",
  "Dedos o labios color azul/morado",
  "Convulsiones",
]

function SurveyStepTwo({ location }) {
  const header = (
    <>
      <Typography align="center" variant="h5">
        Marca si has presentado alguno(s) de los siguientes síntomas en las
        <strong> últimas dos semanas.</strong>
      </Typography>
      <Typography variant="subtitle1" align="center">
        (Puedes continuar sin seleccionar ninguno)
      </Typography>
    </>
  )

  return (
    <React.Fragment>
      <AppAppBar />
      <Questions
        questions={questions}
        header={header}
        step={2}
        next="/survey/steps/three/"
        previousState={location.state}
      />
      <AppFooter />
    </React.Fragment>
  )
}

export default withRoot(SurveyStepTwo)
